import { BookmarkTypes } from '@/constants/bookmarks/bookmarkType'
import GigListItem from '@/models-ts/gigs/GigListItem'
import JobListItem from '@/models-ts/job/JobListItem'
import VacancyListItem from '@/models-ts/vacancies/VacancyListItem'

export default class BookmarkListItem {
  id: number | string
  type: number | string
  entityId: number | string
  relations: {
    Vacancy: VacancyListItem | null
    Job: JobListItem | null
    Gig: GigListItem | null
  }

  constructor({ id, type, entityId, relations }: Partial<BookmarkListItem>) {
    Object.assign(this, { id, type, entityId, relations })
  }

  static fromServer(props: LX.BookmarkListItem) {
    const entityId = BookmarkListItem.getEntityId(props)
    return new BookmarkListItem({
      ...props,
      entityId,
      relations: {
        Vacancy: props.relations?.Vacancy ? VacancyListItem.fromServer(props.relations.Vacancy) : null,
        Job: props.relations?.Job ? JobListItem.fromServer(props.relations.Job) : null,
        Gig: props.relations?.Gig ? GigListItem.fromServer(props.relations.Gig) : null,
      },
    })
  }

  static getEntityId(props: LX.BookmarkListItem) {
    switch (props.type) {
      case BookmarkTypes.VACANCY:
        return props.vacancy_id
      case BookmarkTypes.JOB:
        return props.job_id
      case BookmarkTypes.GIG:
        return props.gig_id
    }
  }
}
